import { getArenas, patchArena, createArena } from '@fno/service/api/arenas.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/hello/task/helpers.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import arenaSchema from 'fanx-schema/resource/arena'
import template from './Venues.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    arenas: {
        type: Array,
        schema: arenaSchema,
        patch: arena => patchArena({ arena }),
        post: arena => createArena({ arena })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.venues`

    stateRouter.addState({
        name,
        route: '/venues',
        template,
        data: {
            title: 'Venues | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ arenas ] = await Promise.all([
                getArenas({ schoolId })
            ])

            return setContextOriginal({
                context: {
                    form: {
                        arenas: arenas.map(arena => transformApiResponseToFormObject({ schema: arenaSchema, data: arena }))
                    }
                }
            }, preFormMutator)
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'VENUES',
                nextId: 'teams'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'appColors', schoolId))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
